import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const MaskLines = ({ lines, className = "", delay = 0, onView = false, lineClass = "" }) => {
  const trigger = onView
    ? { whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { animate: "show" };
  return (
    <motion.span className={`block ${className}`} initial="hide" {...trigger}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className={`block ${lineClass}`}
            variants={{ hide: { y: "105%" }, show: { y: "0%" } }}
            transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const FadeUp = ({ children, className = "", delay = 0, as = "div", ...rest }) => {
  const C = motion[as];
  return (
    <C
      className={className}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </C>
  );
};

export const Eyebrow = ({ children, light = false, className = "" }) => (
  <p className={`flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] ${light ? "text-zinc-300" : "text-zinc-700"} ${className}`}>
    <span className="inline-block h-2 w-2 bg-[#FF5A00]" />
    {children}
  </p>
);
